import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useEffect } from 'react';
import { deleteSubcategoryHttp, getSubcategoryByBranchIdHttp } from '../services/SubcategoryService';
import { deleteCategoryHttp, getCategoryByBranchIdHttp } from '../services/CategoryService';
import { CATEGORY, SUBCATEGORY } from './AdminPanelOperations';
import { getBranchOptionsHttp, getCategoryOptionsByBranchHttp } from '../services/OptionService';
import SelectOption from '../components/input/SelectOption';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const categories = [
    "Kategoriler",
    "Alt Kategoriler",
    "Ürünler",
]


const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

export default function AdminPanelList() {
    let { entity } = useParams();
    const [data, setData] = useState();
    const [branchOptions, setBranchOptions] = useState();
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const navigateTo = useNavigate();

    const handleEditButtonClick = (id) => {
        navigateTo(`/admin-panel/update/${entity}/${id}`)
    }
    const handleDeleteButtonClick = (id) => {
        if(entity === CATEGORY){
            deleteCategoryHttp(id).finally(()=>navigateTo("/admin-panel"))
        }else if (entity === SUBCATEGORY) {
            deleteSubcategoryHttp(id).finally(()=>navigateTo("/admin-panel"))
        }
    }
    
    useEffect(() => {
        setData([])
      }, [entity])

    useEffect(() => {
        if(selectedBranchId){
            if(entity === CATEGORY){
                getCategoryByBranchIdHttp(selectedBranchId).then((resp)=>setData(resp.data))
            }else if (entity === SUBCATEGORY) {
                getSubcategoryByBranchIdHttp(selectedBranchId).then((resp)=>setData(resp.data))
            }
        }
        getBranchOptionsHttp().then((resp)=>setBranchOptions(resp.data))
    }, [selectedBranchId])

    
    

  return (
    <Box margin={1}>
        <SelectOption
            label="Şube"
            options={branchOptions}
            value={selectedBranchId}
            onChange={(e) => setSelectedBranchId(e.target.value)}
        />
        {data &&
            <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell width={80}></TableCell>
                    <TableCell><b>Kategori İsmi/Açıklaması</b></TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {data.map((row) => (
                    <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        
                    <TableCell>
                        <IconButton aria-label="update"
                            onClick={(e)=>{
                                handleEditButtonClick(row.id)
                            }}
                        >
                            <EditIcon />
                        </IconButton>
                        <IconButton aria-label="delete"
                            onClick={(e)=>{
                                handleDeleteButtonClick(row.id)
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row" sx={{paddingX:0}}>
                        <b>{row.name}</b>
                        <br />
                        {row.description}
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        }
    </Box>
  );
}